import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Home from '@/pages/home';
import { ROUTES } from '@/config/routes';

export default function Routes() {
  return (
    <Switch>
      <Route exact path={ROUTES.home} component={Home} />
    </Switch>
  );
}
